import branchManagementRoutesComponent from './routes.component';
import printRoutesModule from './print';

let branchManagementRoutesModule = angular.module('branchManagementRoutes', [
  printRoutesModule
])
  .component('branchManagementRoutes', branchManagementRoutesComponent)
  .name;

export default branchManagementRoutesModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/routes/index.js